import React, { useContext, useState, useEffect } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { useDrawingArea } from "@mui/x-charts/hooks";
import { styled } from "@mui/material/styles";
import Profile from "../../assets/BuyerProfile/Overview/DefaultImg.png";
import OverView from "./Overview.css";
import { Formik } from "formik";
import { CircularProgress } from "@mui/material";
import {
  createUserWithEmailAndPassword,
  getAuth,
  signInWithEmailAndPassword,
  signOut,
  updateProfile,
} from "@firebase/auth";
import { commonPoint } from "../../common/Apicall";
import { buyerOverviewAPI, userProfileDetailsApi } from "../../Apis/UserApi";
import { UserAuthContext } from "../../App";
import { changeAccountTypeApi } from "../../Apis/PaymentApi";
import { useNavigate } from "react-router-dom";


const SocialIcons = [
  {
    type: "Google",
    img: require("../../assets/LoginPage/Social_Icons/google.png"),
  },
  {
    type: "microsoft",
    img: require("../../assets/LoginPage/Social_Icons/microsoft.png"),
  },
  {
    type: "outlook",
    img: require("../../assets/LoginPage/Social_Icons/outlook.png"),
  },
  {
    type: "facebook",
    img: require("../../assets/LoginPage/Social_Icons/facebook.png"),
  },
];

const options = [
  { value: "India", label: "India" },
  { value: "USA", label: "USA" },
  { value: "China", label: "China" },
  { value: "Japan", label: "Japan" },
];

const Overview = () => {
  const [sellerPopUp, setSellerPopUp] = useState(false);
  const [emailStatus, setEmailStatus] = useState("");
  const [loader, setLoader] = useState(false);
  const [verifySeller, setVerifySeller] = useState(false);
  const [userData, setUserData] = useState({
    uid: "",
    name: "",
    email: "",
    phone: "",
    billingAddress: "",
    accountType: "",
    gstNumber: "",
    storeName: "",
    country: "",
  });
  const [buyerOverview, setBuyerOverview] = useState({
    inquiryCount: 0,
    wishlistCount: 0,
    orderCount: 0,
    AcceptedCount: 0,
    InProgressCount: 0,
    PendingCount: 0,
    RejectedCount: 0,
  });
  const navigate = useNavigate();

  const toggleVerifyName = () => {
    setVerifySeller((prev) => !prev);
  };

  const toggleRegisterForm = () => {
    setSellerPopUp((prev) => !prev);
  };

  const size = {
    width: 400,
    height: 200,
  };

  const StyledText = styled("text")(({ theme }) => ({
    fill: theme.palette.text.primary,
    textAnchor: "middle",
    dominantBaseline: "central",
    fontSize: 20,
  }));

  function PieCenterLabel({ children }) {
    const { width, height, left, top } = useDrawingArea();
    return (
      <StyledText x={left + width / 2} y={top + height / 2}>
        {children}
      </StyledText>
    );
  }

  // signup function
  async function firebaseSignup(values) {
    try {
      const storeResponse = await fetch(
        `${commonPoint}/api/v1/store/registerSeller`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            storeID: userData?.uid,
            storeDesc: "",
            storeLogo: "",
            phoneNumber: userData?.phone || values.phoneNumber,
            storeName: values.storeName,
            storeAddress: values.address,
            city: values.city,
            country: values.country,
            state: values.state,
            gstNumber: userData?.gstNumber || values.gstNumber,
            postcode: "400050",
            isVerified: 0,
          }),
        }
      );

      if (!storeResponse.ok) {
        console.error("Store registration failed");
      }

      const response = await storeResponse.json();
      if (response?.message === "Store created successfully") {
        await changeAccountTypeApi();
      }

      toggleRegisterForm();
    } catch (error) {
      console.error("Error:", error);
    }
  }

  const { userUid } = useContext(UserAuthContext);

  // fetch user / buyer details
  const fetchUserDetails = async () => {
    try {
      const response = await userProfileDetailsApi(userUid?.currentUser?.uid);
      setUserData({
        uid: userUid?.currentUser?.uid,
        name: userUid?.currentUser?.displayName,
        email: userUid?.currentUser?.email,
        billingAddress: response?.userData?.billingAddress,
        phone: response?.userData?.phoneNumber,
        accountType: response?.userData?.accountType,
        gstNumber: response?.userData?.gstNumber,
        storeName: response?.userData?.storeName,
      });
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  useEffect(() => {
    if (userUid?.currentUser?.uid)
      fetchUserDetails();
  }, [userUid?.currentUser?.uid]);

  const buyerOverviewDetails = async () => {
    try {
      const buyerOverview = await buyerOverviewAPI(userUid?.currentUser?.uid);
      if (
        buyerOverview &&
        buyerOverview.profileData &&
        buyerOverview.profileData.length > 0
      ) {
        setBuyerOverview(buyerOverview.profileData[0]);
      }
    } catch (error) {
      console.log("Error fetching profile overview", error);
    }
  };

  useEffect(() => {
    if (userUid?.currentUser?.uid) {
      buyerOverviewDetails();
    }
  }, [userUid?.currentUser?.uid]);

  const data = [
    {
      name: "Orders Complete",
      value: parseInt(buyerOverview.AcceptedCount),
      color: "#72C62F",
    },
    {
      name: "Orders In Process",
      value: parseInt(buyerOverview.InProgressCount),
      color: "#7297F6",
    },
    {
      name: "Orders Cancelled",
      value: parseInt(buyerOverview.RejectedCount),
      color: "#FF5454",
    },
  ];

  const handleViewAllInquiries = () => {
    navigate("/orders/inquiry/"); // Redirect to inquiries page
  };

  const handleViewAllWishlists = () => {
    navigate("/orders/whishlist"); // Redirect to wishlist page
  };



  return (
    <div className="w-[1014px] h-[590px] bg-[#FFF9F2] rounded-r-[10px] flex flex-row">
      <div className="w-[722px] h-[590px] flex flex-col p-[32px]">
        <div className="w-full h-[70px] flex justify-between items-start">
          <div className="w-[200px] h-[55px] flex flex-col gap-y-[10px]">
            <p className="w-[86px] h-[35px] font-semibold text-[18px] flex items-end">
              Overview
            </p>
            <hr className="w-[186px] h-[3px] bg-[#FF6300]" />
          </div>
          {userData?.accountType === "buyer" && (
            <div className="w-[300px] h-[60px] flex flex-col text-end gap-y-[8px]">
              <p className="w-[300px] h-[21px] font-medium text-[14px]">
                Want additional features as a buyer ?
              </p>
              <button
                className="w-[300px] h-[21px] font-semibold text-[14px] text-[#FF6300] text-end"
                onClick={toggleRegisterForm}
              >
                Become a Seller
              </button>

              {sellerPopUp && (
                <div className="fixed inset-0 flex items-center justify-center bg-black h-[710px] bg-opacity-50 z-50">
                  <div className="w-[606px] h-[690px] bg-white rounded-[10px] items-center justify-between text-center">
                    <div className="w-full">
                      <div className="flex items-center justify-between">
                        <div className="w-[174px] h-[27px] flex-shrink-0 mt-[13px] ml-[29px] text-[18px] font-semibold text-[#FF8100] leading-[27px] text-start select-none">
                          Seller Registration
                        </div>
                      </div>
                    </div>
                    <Formik
                      initialValues={{
                        name: "",
                        phoneNumber: "",
                        email: "",
                        storeName: "",
                        gstNumber: "",
                        isAgree: false,
                        country: "",
                        state: "",
                        city: "",
                        address: "",
                      }}
                      validate={(values) => {
                        const errors = {};
                        // name
                        if (!userData?.name && !values.name) {
                          errors.name = "Required";
                        }

                        // phoneNumber
                        if (
                          !userData?.phone &&
                          (!values.phoneNumber ||
                            !/^\+?\d{10,15}$/i.test(values.phoneNumber))
                        ) {
                          errors.phoneNumber = !values.phoneNumber
                            ? "Required"
                            : "Invalid Phone Number";
                        }

                        // email
                        if (!userData?.email) {
                          if (!values.email) {
                            errors.email = "Required";
                          } else if (
                            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                              values.email
                            )
                          ) {
                            errors.email = "Invalid email address";
                          }
                        }

                        // gstNumber
                        if (!userData?.gstNumber) {
                          if (!values.gstNumber) {
                            errors.gstNumber = "Required";
                          } else if (
                            !/^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/i.test(
                              values.gstNumber
                            )
                          ) {
                            errors.gstNumber = "Invalid GST Number";
                          }
                        }

                        if (!values.isAgree)
                          errors.isAgree =
                            "You must agree to the terms and conditions";

                        return errors;
                      }}
                      onSubmit={async (values) => {
                        try {
                          firebaseSignup(values);
                        } catch (err) {
                          console.log("Firebase error");
                        }
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                      }) => (
                        <div>
                          <div className="flex gap-x-[45px] w-full pl-[29px] mt-[10px]">
                            <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                              <p className="text-[14px] font-medium w-[45px] h-[21px] text-black">
                                Name
                              </p>
                              <input
                                name="name"
                                disabled={userData?.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={userData?.name || values.name}
                                className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                placeholder="Enter your name"
                              />
                              {errors.name && (
                                <p className="text-red-600 text-[12px]">
                                  {errors.name}
                                </p>
                              )}
                            </div>

                            <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                              <p className="text-[14px] font-medium w-[109px] h-[21px] text-black">
                                Phone Number
                              </p>
                              <input
                                maxLength={10}
                                name="phoneNumber"
                                disabled={userData?.phone}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={userData?.phone || values.phoneNumber}
                                className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                placeholder="Enter your phone number"
                              />
                              {errors.phoneNumber && (
                                <p className="text-red-600 text-[12px]">
                                  {errors.phoneNumber}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="flex flex-col float-start pl-[29px] text-left w-full mt-[10px]">
                            <p className="text-[14px] font-medium w-[109px] text-black">
                              Email
                            </p>
                            <input
                              name="email"
                              disabled={true}
                              onBlur={handleBlur}
                              value={userData.email}
                              className="w-[526px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                              placeholder="Enter your Email ID"
                            />
                            {errors.email && (
                              <p className="text-red-600 text-[12px]">
                                {errors.email}
                              </p>
                            )}
                          </div>

                          <div className="flex gap-x-[45px] w-full pl-[29px] mt-[10px]">
                            <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                              <div className="flex items-center">
                                <p className="text-[14px] font-medium w-[88px] h-[21px] text-black">
                                  Store Name
                                </p>
                              </div>
                              <input
                                name="storeName"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.storeName}
                                className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                placeholder="Enter your Store name"
                              />
                              {errors.storeName && (
                                <p className="text-red-600 text-[12px]">
                                  {errors.storeName}
                                </p>
                              )}
                              {/* {isWantToBeSeller === true ? (
                              <div>
                                <p className="text-[10px] font-normal w-[220px] h-[15px] text-black mt-[4px]">
                                  https://naayatrade.com/store/
                                  {values.storeName}
                                </p>
                              </div>
                            ) : (
                              ""
                            )} */}
                            </div>

                            <div className="flex flex-col float-start ml-0 text-left w-[240px]">
                              <div className="flex items-center">
                                <p className="text-[14px] font-medium w-[93px] h-[21px] text-black">
                                  GST Number
                                </p>
                              </div>
                              <input
                                name="gstNumber"
                                disabled={userData?.gstNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={userData?.gstNumber || values.gstNumber}
                                className="w-[240px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                placeholder="Enter your 15 Digit GST number"
                              />
                              {errors.gstNumber && (
                                <p className="text-red-600 text-[12px]">
                                  {errors.gstNumber}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="flex mt-[5px] w-full pl-[29px] gap-x-[17px]">
                            <div className="flex flex-col ml-0 text-left w-[164px]">
                              <p className="text-[14px] font-medium w-[59px] text-black">
                                Country
                              </p>
                              <select
                                className="w-[163px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                name="country" // Make sure the name matches the field name in initialValues
                                value={values.country} // Set the value from Formik's state
                                onChange={handleChange} // Call handleChange to update Formik's state
                              >
                                <option className="text-[#B3B3B3]" value="">
                                  Select Country
                                </option>
                                {options.map((option) => (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="col-start-4 col-end-7">
                              <div className="flex flex-col float-start ml-0 text-left w-[164px]">
                                <p className="text-[14px] font-medium w-[59px] text-black">
                                  State
                                </p>
                                <select
                                  className="w-[163px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                  name="state"
                                  value={values.state}
                                  onChange={handleChange}
                                >
                                  <option className="text-[#B3B3B3]" value="">
                                    Select State
                                  </option>
                                  {options.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-start-7 col-end-13">
                              <div className="flex flex-col float-start ml-0 text-left w-[164px]">
                                <p className="text-[14px] font-medium w-[59px] text-black">
                                  City
                                </p>
                                <select
                                  className="w-[163px] h-[31px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3]"
                                  name="city"
                                  value={values.city}
                                  onChange={handleChange}
                                >
                                  <option className="text-[#B3B3B3]" value="">
                                    Select City
                                  </option>
                                  {options.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                          <div className="flex flex-col float-start pl-[29px] text-left w-full mt-[5px]">
                            <p className="text-[14px] font-medium w-[109px] h-[21px] text-black">
                              Address
                            </p>
                            <textarea
                              name="address"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.address}
                              rows="2"
                              maxlength="150"
                              className="w-[526px] h-[55px] rounded-[5px] border-[1px] drop-shadow-[0_0px_0.5px_rgba(0,0,0,0.20)] mt-[5px] px-[11px] py-[4px] text-[12px] font-medium placeholder-[#B3B3B3] resize-none"
                              placeholder="Enter Company Address"
                            />
                          </div>

                          <div className="flex pt-[10px] w-[548px] gap-x-[12px] ml-[29px] ">
                            <label>
                              <input
                                name="isAgree"
                                className="h-[20px] w-[20px]"
                                type="checkbox"
                                value={values.isAgree}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                            </label>
                            <p className="text-[12px] pr-[10px] font-medium text-left w-[500px]">
                              I Agree To Terms & Conditions I agree to
                              <span className="text-[#FF6300]">
                                {" "}
                                (a) Terms Of Use{" "}
                              </span>
                              and
                              <span className="text-[#FF6300]">
                                {" "}
                                (b) Privacy Policy.
                              </span>{" "}
                              I agree to receive more information from
                              Naayatrade.com about its products and services.
                            </p>
                          </div>
                          {errors.isAgree && (
                            <p className="text-red-600 text-[12px]">
                              {errors.isAgree}
                            </p>
                          )}
                          {emailStatus && (
                            <p className="text-red-600 text-[12px]">
                              {emailStatus}
                            </p>
                          )}

                          <div className="w-full flex items-center justify-center">
                            {!loader ? (
                              <button
                                type="submit"
                                onClick={() => {
                                  handleSubmit();
                                  toggleVerifyName();
                                }}
                                className="text-white bg-[#FF6300] w-[130px] h-[48px] rounded-[10px] mt-[15px] flex items-center justify-center"
                              >
                                REGISTER
                              </button>
                            ) : (
                              <button className="register-button text-white bg-[#FF6300] w-[130px] h-[48px] rounded-[10px] mt-[15px] flex items-center justify-center">
                                <CircularProgress color="inherit" size={24} />
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                    </Formik>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>


        <div className="flex flex-col gap-y-[17px]">
          <div className="flex flex-row gap-x-[21px] w-full h-[118px]">
            <div className="w-[208px] h-[105px] bg-white rounded-[10px] pt-[20px] pb-[8px] pr-[13px] flex flex-row drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
              <hr className="w-[9px] h-[57px] bg-[#849FFF] rounded-r-[7px]" />
              <div className="flex flex-col text-start items-start justify-between ml-[14px] h-[66px]">
                <h4 className="w-[126px] h-[21px] text-black font-semibold text-[14px]">
                  My Inquiries
                </h4>
                <p className="w-[25px] h-[36px] font-semibold text-[24px] text-start text-black">
                  {buyerOverview.inquiryCount}
                </p>
              </div>
              <div className="flex flex-col text-end items-end justify-between h-[73px]">
                <svg
                  width="34"
                  height="36"
                  viewBox="0 0 44 47"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_181_6710)">
                    <path
                      d="M23.4709 4.23985L33.6918 8.9183C34.5718 9.32172 35.2739 10.0718 35.6534 11.0137L40.0314 21.9295C40.4348 22.9321 40.4348 24.068 40.0314 25.0706L35.6516 35.9883C35.2739 36.9283 34.5718 37.6784 33.6899 38.0838L23.4709 42.7603C22.5323 43.1911 21.4689 43.1911 20.5303 42.7603L10.3094 38.0818C9.4278 37.6785 8.72535 36.9281 8.34776 35.9864L3.96976 25.0706C3.77064 24.5743 3.66797 24.04 3.66797 23.5001C3.66797 22.9601 3.77064 22.4258 3.96976 21.9295L8.34959 11.0118C8.72726 10.0718 9.42942 9.32172 10.3113 8.91635L20.5303 4.23985C20.9949 4.02715 21.4951 3.91748 22.0006 3.91748C22.5061 3.91748 23.0063 4.02715 23.4709 4.23985Z"
                      stroke="#D9D9D9"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M22 31.3335V31.3531"
                      stroke="#D9D9D9"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M22 25.4584C22.8245 25.461 23.6259 25.1667 24.2745 24.623C24.9232 24.0793 25.3814 23.3179 25.5751 22.4618C25.7688 21.6056 25.6867 20.7048 25.342 19.9046C24.9974 19.1045 24.4103 18.4518 23.6757 18.0519C22.9463 17.6529 22.112 17.5291 21.3085 17.7009C20.5049 17.8726 19.7794 18.3297 19.25 18.9978"
                      stroke="#D9D9D9"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_181_6710">
                      <rect width="44" height="47" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <button className="w-[47px] h-[18px] text-[#FF6300] font-medium text-[12px] text-end"
                  onClick={handleViewAllInquiries}>
                  View All
                </button>
              </div>
            </div>

            <div className="w-[208px] h-[105px] bg-white rounded-[10px] pt-[20px] pb-[8px] pr-[13px] flex flex-row gap-x-[14px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
              <hr className="w-[9px] h-[57px] bg-[#FFD233] rounded-r-[7px]" />
              <div className="flex flex-col">
                <div className="flex flex-row items-start justify-between w-[170px]">
                  <h4 className="w-[123px] h-[21px] text-black font-semibold text-[14px]">
                    Wishlist Products
                  </h4>
                  <svg
                    width="34"
                    height="36"
                    viewBox="0 0 44 47"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_181_6715)">
                      <path
                        d="M35.7504 24.6202L22.0004 39.1667L8.25039 24.6202C7.34345 23.6775 6.62907 22.5444 6.15223 21.2923C5.67539 20.0402 5.44642 18.6962 5.47974 17.3449C5.51306 15.9936 5.80795 14.6643 6.34584 13.4407C6.88373 12.2172 7.65297 11.1258 8.60511 10.2354C9.55726 9.34502 10.6717 8.67485 11.8782 8.26711C13.0847 7.85937 14.3572 7.72289 15.6156 7.86628C16.8739 8.00966 18.0908 8.4298 19.1897 9.10023C20.2885 9.77067 21.2455 10.6769 22.0004 11.7618C22.7585 10.6848 23.7166 9.78646 24.8147 9.12314C25.9128 8.45982 27.1273 8.04575 28.3821 7.90685C29.6369 7.76795 30.905 7.9072 32.1071 8.31589C33.3092 8.72458 34.4194 9.39392 35.3682 10.282C36.317 11.1701 37.084 12.2578 37.6212 13.4771C38.1583 14.6964 38.4541 16.0209 38.49 17.3679C38.5258 18.7149 38.301 20.0553 37.8296 21.3052C37.3582 22.5552 36.6504 23.6877 35.7504 24.632"
                        stroke="#D9D9D9"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_181_6715">
                        <rect width="44" height="47" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="w-[170px] flex flex-row justify-between">
                  <p className="w-[25px] h-[30px] font-semibold text-[24px] text-black">
                    {buyerOverview.wishlistCount}
                  </p>
                  <button className="w-[47px] h-[36px] text-[#FF6300] font-medium text-[12px] items-end flex"
                    onClick={handleViewAllWishlists}>
                    View All
                  </button>
                </div>
              </div>
            </div>

            <div className="w-[208px] h-[105px] bg-white rounded-[10px] pt-[20px] pb-[8px] pr-[13px] flex flex-row gap-x-[14px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
              <hr className="w-[9px] h-[57px] bg-[#6FC33B] rounded-r-[7px]" />
              <div className="flex flex-col">
                <div className="flex flex-row items-start justify-between w-[170px]">
                  <h4 className="w-[128px] h-[21px] text-black font-semibold text-[14px]">
                    Unread Messages
                  </h4>
                  <svg
                    width="34"
                    height="36"
                    viewBox="0 0 44 47"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_181_6718)">
                      <path
                        d="M14.666 17.625H29.3327"
                        stroke="#D9D9D9"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14.666 25.4585H25.666"
                        stroke="#D9D9D9"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16.5 35.2502H11C9.54131 35.2502 8.14236 34.6312 7.11091 33.5294C6.07946 32.4276 5.5 30.9333 5.5 29.3752V13.7085C5.5 12.1503 6.07946 10.656 7.11091 9.55424C8.14236 8.45247 9.54131 7.8335 11 7.8335H33C34.4587 7.8335 35.8576 8.45247 36.8891 9.55424C37.9205 10.656 38.5 12.1503 38.5 13.7085V29.3752C38.5 30.9333 37.9205 32.4276 36.8891 33.5294C35.8576 34.6312 34.4587 35.2502 33 35.2502H27.5L22 41.1252L16.5 35.2502Z"
                        stroke="#D9D9D9"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_181_6718">
                        <rect width="44" height="47" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="w-[170px] flex flex-row justify-between">
                  <p className="w-[15px] h-[30px] font-semibold text-[24px] text-black">
                    0
                  </p>
                  {/* <button className="w-[47px] h-[36px] text-[#FF6300] font-medium text-[12px] items-end flex">
                    View All
                  </button> */}
                </div>
              </div>
            </div>
          </div>

          <div className="w-[658px] h-[239px] bg-white rounded-[10px] pt-[20px] flex flex-row drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
            <hr className="w-[9px] h-[57px] bg-[#FF6300] rounded-r-[7px]" />

            <div className="w-[220px] h-[180px] flex flex-col text-start gap-y-[25px] ml-[27px]">
              <h2 className="w-[131px] h-[24px] text-black font-semibold text-[16px]">
                Order Summary
              </h2>
              <div className="w-[180px] gap-x-[13px] flex items-center">
                <p className="w-[13px] h-[13px] bg-[#72C62F] rounded-full"></p>
                <p className="w-[121px] h-[21px] font-medium text-[14px] text-black">
                  Orders Complete
                </p>
                <p className="w-[15px] h-[24px] font-semibold text-[16px] text-black">
                  {buyerOverview.AcceptedCount}
                </p>
              </div>
              <div className="w-[180px] gap-x-[13px] flex items-center">
                <p className="w-[13px] h-[13px] bg-[#7297F6] rounded-full"></p>
                <p className="w-[125px] h-[21px] font-medium text-[14px] text-black">
                  Orders In Process
                </p>
                <p className="w-[15px] h-[24px] font-semibold text-[16px] text-black">
                  {buyerOverview.InProgressCount}
                </p>
              </div>
              <div className="w-[200px] gap-x-[13px] flex items-center">
                <p className="w-[13px] h-[13px] bg-[#FF5454] rounded-full"></p>
                <p className="w-[125px] h-[21px] font-medium text-[14px] text-black">
                  Orders Cancelled
                </p>
                <p className="w-[15px] h-[24px] font-semibold text-[16px] text-black">
                  {buyerOverview.RejectedCount}
                </p>
              </div>
            </div>

            <div>
              <PieChart series={[{ data, innerRadius: 82 }]} {...size}>
                <PieCenterLabel
                  className={`w-[100px] h-[24px] font-semibold text-[16px] text-black`}
                >
                  Total Orders
                </PieCenterLabel>
              </PieChart>
            </div>
          </div>
        </div>
      </div>

      <div className="w-[292px] h-[590px] bg-white rounded-r-[10px] flex flex-col p-[16px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
        <div className="flex flex-row gap-x-[15px] mt-[24px]">
          <img src={Profile} alt="" className="w-[65px] h-[65px]" />
          <div className="flex flex-col w-auto gap-y-[7px]">
            <p className="w-auto h-[24px] font-semibold text-[16px] text-black">
              {userData?.name}
            </p>
            <button className="w-[98px] h-[26px] bg-[#FF6300] text-white rounded-[5px] font-medium text-[12px]">
              Edit Profile
            </button>
          </div>
        </div>

        <hr className="w-[250px] h-[2px] bg-[#EFEFEF] mt-[35px] rounded-full" />

        <div className="flex flex-col pl-[10px]">
          <div className="flex flex-row items-center justify-start gap-x-[8px] mt-[33px]">
            <p className="w-[34px] h-[34px] bg-[#FFF7CB] rounded-full flex items-center justify-center">
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.9654 19.5669C14.2202 19.5672 13.4878 19.3727 12.8408 19.0028L12.7496 18.9514C8.54319 16.5452 5.02405 13.1006 2.52837 8.94671L2.05261 8.15378C1.56534 7.34313 1.36342 6.3927 1.47904 5.45397C1.59466 4.51523 2.02116 3.64221 2.69058 2.97402L3.63848 2.02612C4.43503 1.22957 5.73051 1.22957 6.52634 2.02612L8.61475 4.11454C8.92905 4.43032 9.13187 4.83993 9.1925 5.28132C9.25313 5.72272 9.16826 6.17184 8.95075 6.56068L8.16579 7.95464C8.14929 7.98397 8.14284 8.01789 8.14741 8.05123C8.15199 8.08457 8.16734 8.1155 8.19113 8.1393L12.8408 12.789C12.865 12.8127 12.8962 12.8279 12.9298 12.8323C12.9633 12.8368 12.9974 12.8302 13.0269 12.8136L14.4187 12.0294L14.4194 12.0286C14.8083 11.8114 15.2574 11.7266 15.6987 11.7873C16.1401 11.8479 16.5497 12.0506 16.8656 12.3646L18.9547 14.4545C19.7513 15.2511 19.7513 16.5465 18.9547 17.3424L17.9648 18.3315C17.5706 18.7245 17.1028 19.0358 16.5881 19.2478C16.0734 19.4598 15.522 19.5682 14.9654 19.5669ZM5.08241 2.87699C4.93034 2.87699 4.77827 2.93492 4.66241 3.05078L3.71451 3.99795C3.27392 4.43775 2.99321 5.01235 2.91709 5.63021C2.84097 6.24806 2.97384 6.87361 3.29451 7.40719L3.77027 8.20012C6.13758 12.1407 9.47569 15.4085 13.4658 17.6914L13.557 17.7428C14.662 18.375 16.0524 18.1961 16.9402 17.3069L17.9301 16.3177C17.9852 16.2626 18.029 16.1971 18.0589 16.125C18.0887 16.053 18.1041 15.9757 18.1041 15.8977C18.1041 15.8197 18.0887 15.7425 18.0589 15.6704C18.029 15.5983 17.9852 15.5329 17.9301 15.4777L15.8409 13.3878C15.749 13.2965 15.6297 13.2375 15.5013 13.22C15.3728 13.2025 15.2422 13.2274 15.1291 13.2908L13.7373 14.0751C13.4321 14.2459 13.0796 14.3127 12.7331 14.2652C12.3866 14.2178 12.0649 14.0588 11.8169 13.8122L7.1672 9.1625C6.92037 8.91477 6.76114 8.59324 6.71369 8.24676C6.66625 7.90028 6.73319 7.54778 6.90434 7.24281L7.6893 5.84957C7.75237 5.73649 7.77694 5.60595 7.75931 5.47768C7.74167 5.3494 7.68279 5.23034 7.59154 5.13847L5.50241 3.05078C5.44729 2.99558 5.38181 2.95182 5.30974 2.92199C5.23766 2.89217 5.16041 2.87687 5.08241 2.87699Z"
                  fill="#F7C135"
                />
              </svg>
            </p>
            <p className="w-[58px] h-[20px] font-semibold text-[14px]">
              Contact
            </p>
          </div>

          <p className="w-[83px] h-[28px] font-medium text-[14px] text-black mt-[7px]">
            {userData?.phone}
          </p>

          <div className="flex flex-row items-center justify-start gap-x-[8px] mt-[31px]">
            <p className="w-[34px] h-[34px] bg-[#E9F0FF] rounded-full flex items-center justify-center">
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.25 5.25C19.25 4.2875 18.4625 3.5 17.5 3.5H3.5C2.5375 3.5 1.75 4.2875 1.75 5.25V15.75C1.75 16.7125 2.5375 17.5 3.5 17.5H17.5C18.4625 17.5 19.25 16.7125 19.25 15.75V5.25ZM17.5 5.25L10.5 9.625L3.5 5.25H17.5ZM17.5 15.75H3.5V7L10.5 11.375L17.5 7V15.75Z"
                  fill="#4D61CA"
                />
              </svg>
            </p>
            <p className="w-[57px] h-[20px] font-semibold text-[14px]">
              Email ID
            </p>
          </div>

          <p className="w-[183px] h-[28px] font-medium text-[14px] text-black mt-[7px]">
            {userData?.email}
          </p>

          <div className="flex flex-row items-center justify-start gap-x-[8px] mt-[37px]">
            <p className="w-[34px] h-[34px] bg-[#DDFFCD] rounded-full flex items-center justify-center">
              <svg
                width="21"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.0007 1.75C8.23254 1.75 6.53685 2.4875 5.28661 3.80025C4.03636 5.11301 3.33398 6.89348 3.33398 8.75C3.33398 13.475 9.20898 18.8125 9.45898 19.04C9.60993 19.1756 9.80202 19.2501 10.0007 19.2501C10.1993 19.2501 10.3914 19.1756 10.5423 19.04C10.834 18.8125 16.6673 13.475 16.6673 8.75C16.6673 6.89348 15.9649 5.11301 14.7147 3.80025C13.4645 2.4875 11.7688 1.75 10.0007 1.75ZM10.0007 17.1937C8.22565 15.4437 5.00065 11.6725 5.00065 8.75C5.00065 7.35761 5.52744 6.02226 6.46512 5.03769C7.4028 4.05312 8.67457 3.5 10.0007 3.5C11.3267 3.5 12.5985 4.05312 13.5362 5.03769C14.4739 6.02226 15.0007 7.35761 15.0007 8.75C15.0007 11.6725 11.7757 15.4525 10.0007 17.1937ZM10.0007 5.25C9.34138 5.25 8.69691 5.45527 8.14875 5.83986C7.60059 6.22444 7.17334 6.77107 6.92105 7.41061C6.66876 8.05015 6.60275 8.75388 6.73137 9.43282C6.85998 10.1117 7.17745 10.7354 7.64363 11.2249C8.1098 11.7144 8.70375 12.0477 9.35035 12.1827C9.99695 12.3178 10.6672 12.2485 11.2763 11.9836C11.8853 11.7187 12.4059 11.2701 12.7722 10.6945C13.1385 10.1189 13.334 9.44223 13.334 8.75C13.334 7.82174 12.9828 6.9315 12.3577 6.27513C11.7326 5.61875 10.8847 5.25 10.0007 5.25ZM10.0007 10.5C9.67102 10.5 9.34878 10.3974 9.0747 10.2051C8.80062 10.0128 8.587 9.73947 8.46085 9.4197C8.33471 9.09993 8.3017 8.74806 8.36601 8.40859C8.43032 8.06913 8.58905 7.75731 8.82214 7.51256C9.05523 7.26782 9.3522 7.10115 9.6755 7.03363C9.9988 6.9661 10.3339 7.00076 10.6385 7.13321C10.943 7.26566 11.2033 7.48997 11.3864 7.77775C11.5696 8.06554 11.6673 8.40388 11.6673 8.75C11.6673 9.21413 11.4917 9.65925 11.1792 9.98744C10.8666 10.3156 10.4427 10.5 10.0007 10.5Z"
                  fill="#74CA4D"
                />
              </svg>
            </p>
            <p className="w-[61px] h-[28px] text-[14px] font-semibold">
              Location
            </p>
          </div>

          <p className="mt-[13px] w-[237px] h-[112px] font-medium text-[14px] text-black text-start leading-[28px]">
            {userData?.billingAddress}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Overview;
